export var POAEdisMapper = function (resp) {
    if (resp)
        return resp.map(function (v) {
            return {
                accountCode: v.accountCode,
                isinCode: v.isinCode,
                quantity: v.quantity,
                platFormEdis: v.platFormEdis,
                dbUploadStatus: v.dbUploadStatus,
                dbUploadRemark: v.dbUploadRemark,
                dbUploadDatetime: v.dbUploadDatetime,
            };
        });
    return [];
};
